import { Directive, forwardRef, HostBinding, Input } from '@angular/core';

import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import { A11yRole } from '../interfaces/a11y.interfaces';
import { normalizeToken } from '../utils/a11y.util';

import { A11yLabelDirective } from './a11y-label.directive';

const A11Y_LIVE_POLITENESS_VALUES = ['polite', 'assertive', 'off'] as const;
const A11Y_LIVE_ROLES = ['status', 'alert', 'timer'] as const;

@Directive({
  selector: '[khA11yLive]',
  providers: [{ provide: KH_A11Y_TARGET, useExisting: forwardRef(() => A11yLiveDirective) }]
})
export class A11yLiveDirective extends A11yLabelDirective implements A11yRole {
  @Input() public khA11yLive: 'polite' | 'assertive' | 'off' = 'polite';
  @Input() public khA11yLiveRole: 'status' | 'alert' | 'timer' | null = null;

  @HostBinding('attr.role')
  public get role(): 'status' | 'alert' | 'timer' | null {
    if (this.khA11yLiveRole === null || this.khA11yLiveRole === undefined) {
      return null;
    }

    return normalizeToken(this.khA11yLiveRole, A11Y_LIVE_ROLES, 'status');
  }

  @HostBinding('attr.aria-live')
  public get ariaLive(): 'polite' | 'assertive' | 'off' {
    return normalizeToken(this.khA11yLive, A11Y_LIVE_POLITENESS_VALUES, 'polite') ?? 'polite';
  }
}
